<template>

    <div>
        <div class="flex items-center mb-4">
            <h1>Create Campaign</h1>

            <nav>
                <button @click="form.navigation.goBack" type="button" class="alt">Go Back</button>
            </nav>
        </div>

        <div class="top-help-block">
            <div>
                <span class="text-brand-600">*</span> denotes required field
            </div>
        </div>

        <form action="#" method="post" enctype="multipart/form-data" @submit.prevent="form.create()" v-if="form.isLoaded()">

            <CampaignForm v-bind:value="form"></CampaignForm>

            <div class="flex px-1">
                <div class="flex-1">
                    <p class="error-message" v-if="form.noFieldErrors()">
                        {{ form.getErrorMessage() }}
                    </p>
                </div>

                <div>
                    <button type="submit">Create Campaign</button>
                </div>
            </div>
        </form>
        <Loading v-else></Loading>
    </div>

</template>

<script>
import { defineComponent } from "vue";
import {administration} from "../../../app/Support/Props";
import {Campaign} from "../../../app/Campaign/Campaign";
import Loading from "@/components/Support/Loading.vue";
import CampaignForm from "@/components/Admin/Campaign/CampaignForm.vue";

export default defineComponent({
    props: administration,
    components: {CampaignForm,Loading},
    data() {
        return {
            form: new Campaign(this.app)
        }
    },
    mounted() {
        this.form.mountForm(this.$route.params.slug);
    }
});
</script>
